/**
 * Navegação: drawer mobile (.mobile-navigation).
 * Carrossel de produtos no mega menu: usa o elemento swiper-slider no Liquid (swiper-slider.js + base.js).
 */
var mobileNavAbortControllers = new WeakMap();

function resolveMobileNavFromToggle(toggle) {
  var sec = toggle.closest(".shopify-section");
  return (
    (sec && sec.querySelector(".mobile-navigation")) ||
    document.querySelector(".mobile-navigation")
  );
}

var delegatedToggleBound = false;
function ensureDelegatedToggleClick() {
  if (delegatedToggleBound) return;
  delegatedToggleBound = true;
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".mobile-navigation__toggle");
    if (!toggle) return;
    var nav = resolveMobileNavFromToggle(toggle);
    if (nav && typeof nav._openMobileDrawer === "function") {
      nav._openMobileDrawer();
    }
  });
}

function cleanupNavigationInRoot(sectionRoot) {
  if (!sectionRoot || !sectionRoot.querySelectorAll) return;
  sectionRoot.querySelectorAll(".mobile-navigation").forEach(function (root) {
    var ac = mobileNavAbortControllers.get(root);
    if (ac) {
      try {
        ac.abort();
      } catch (e) {}
      mobileNavAbortControllers.delete(root);
    }
    delete root._openMobileDrawer;
    delete root._closeMobileDrawer;
    root.removeAttribute("data-navigation-drawer-bound");
  });
}

function bindMobileNavigationDrawer(root) {
  if (!root || root.getAttribute("data-navigation-drawer-bound") === "true") return;

  var drawer = root.querySelector(".mobile-navigation__drawer");
  var overlay = root.querySelector(".mobile-navigation__overlay");
  var btnBack = root.querySelector(".btn-back");
  if (!drawer || !overlay || !btnBack) return;

  root.setAttribute("data-navigation-drawer-bound", "true");

  var ac = new AbortController();
  mobileNavAbortControllers.set(root, ac);
  var signal = ac.signal;

  function openNav() {
    drawer.classList.add("translate-left-center"),
      document
        .querySelector("main")
        .classList.add("mobile-navigation-show"),
      document.querySelector("body").classList.add("noscroll"),
      overlay.classList.remove("d-none"),
      setTimeout(function () {
        overlay.classList.remove("opacity-0");
      }, 200);
  }

  function closeNav() {
    drawer.classList.remove("translate-left-center"),
      overlay.classList.add("opacity-0"),
      setTimeout(function () {
        overlay.classList.add("d-none"),
          document
            .querySelector("main")
            .classList.remove("mobile-navigation-show");
      }, 500),
      document.querySelector("body").classList.remove("noscroll");
  }

  root._openMobileDrawer = openNav;
  root._closeMobileDrawer = closeNav;

  var closeBtn = root.querySelector("#navigationDrawerClose");
  closeBtn &&
    closeBtn.addEventListener(
      "click",
      function () {
        closeNav();
      },
      { signal: signal }
    );
  overlay.addEventListener(
    "click",
    function () {
      closeNav();
    },
    { signal: signal }
  );

  root.querySelectorAll(".menu-level-1").forEach(function (el) {
    el.addEventListener(
      "click",
      function (e) {
        var panel = e.currentTarget
          .closest("li")
          .querySelector(".mobile-navigation__level-2");
        panel &&
          (e.preventDefault(),
            (root.querySelector(".mobile-navigation__title").innerHTML =
              e.currentTarget.querySelector("span").innerHTML),
            panel.classList.add("translate-left-center"),
            btnBack.classList.remove("opacity-0"));
      },
      { signal: signal }
    );
  });
  btnBack.addEventListener(
    "click",
    function () {
      var level2 = root.querySelector(
        ".mobile-navigation__level-2.translate-left-center"
      );
      level2 &&
        (level2.classList.remove("translate-left-center"),
          btnBack.classList.add("opacity-0"),
          (root.querySelector(".mobile-navigation__title").innerHTML =
            root.querySelector(".mobile-navigation__title").dataset.title));
    },
    { signal: signal }
  );
}

function enhanceNavigation(scope) {
  ensureDelegatedToggleClick();
  var root = scope || document;
  root.querySelectorAll(".mobile-navigation").forEach(bindMobileNavigationDrawer);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    enhanceNavigation(document);
  });
} else {
  enhanceNavigation(document);
}

document.addEventListener("shopify:section:load", function (ev) {
  if (ev.target && ev.target.nodeType === 1) enhanceNavigation(ev.target);
});
document.addEventListener("shopify:section:unload", function (ev) {
  if (ev.target && ev.target.nodeType === 1)
    cleanupNavigationInRoot(ev.target);
});
